import React, { ComponentProps, FC } from 'react';
import EditableLine from '@components/common/editableLine';
import BlockWrapper from '@components/common/BlockWrapper';

interface SelectAutomaticallyBlockProps {
  selectAutomaticallyConfig: {
    description: string;
    elementConfig: ComponentProps<typeof EditableLine>;
  };
}

const SelectAutomaticallyBlock: FC<SelectAutomaticallyBlockProps> = ({ selectAutomaticallyConfig }) => {
  return (
    <BlockWrapper description={selectAutomaticallyConfig.description}>
      <EditableLine {...selectAutomaticallyConfig.elementConfig} />
    </BlockWrapper>
  );
};

export default SelectAutomaticallyBlock;
